import { reduxForm } from 'redux-form/immutable.js';
import {
    compose,
    lifecycle,
    setDisplayName,
    setPropTypes,
    withHandlers,
} from 'react-recompose';
import { bool, func, object } from 'prop-types';

import app from '~/state/ducks/app/actions.js';
import { getSuperPortalList } from '~/state/ducks/organizations/operations.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import SearchForm from '../components/SearchForm.jsx';


export default compose(
    setDisplayName('SearchFormContainer'),
    setPropTypes({
        onSubmit: func.isRequired,
        initialValues: object,
        systemPortalList: bool,
    }),
    reduxForm({
        form: 'common-search',
    }),
    withReduxConnect({
        mapDispatchToProps: {
            handleClear: app.search.results.clear,
            resetSystemPortalList: getSuperPortalList,
        },
    }),
    withHandlers({
        handleReset: ({ handleClear, reset }) => () => {
            handleClear();
            reset();
        },
        handleClearSystemPortalList: ({ resetSystemPortalList, reset }) => () => {
            resetSystemPortalList();
            reset();
        },
    }),
    lifecycle({
        componentDidMount() {
            this.props.handleClear();
        },
    }),
)(SearchForm);
